module.exports = __webpack_public_path__ + "static/Thumb_MMS09_WaitingHi_MM-628fad700122d8a75682da6b7b418340.png";